import React, { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { Modal } from '../../../components/modal/index';
import { useLocale } from '../../../hooks/index';

export type RevokeAccessProps = {
  hasMultipleEmails?: boolean;
  isOpen: boolean;
  onDismiss: () => void;
  onSuccess: () => void;
};

const RevokeAccessModal: FC<RevokeAccessProps> = ({
  isOpen,
  onDismiss,
  onSuccess,
  hasMultipleEmails,
}) => {
  const { messagesLocale } = useLocale();

  return (
    <Modal
      description={
        <AppFormattedMessage
          id={
            hasMultipleEmails
              ? 'REVOKING_STAKEHOLDER_WITH_MULTIPLE_EMAILS'
              : 'NOT_ABLE_TO_USE_STAKEHOLDER'
          }
        />
      }
      dismissButtonContent={<AppFormattedMessage id="NO_KEEP_5" />}
      isOpen={isOpen}
      onDismiss={onDismiss}
      onSuccess={onSuccess}
      successButtonContent={<AppFormattedMessage id="YES_REVOKE" />}
      title={messagesLocale['REVOKE_ACCESS'] + '?'}
    />
  );
};

export default RevokeAccessModal;
